import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-btn",
  "use": "icon-btn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-btn\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 513.2m-275 0a275 275 0 1 0 550 0 275 275 0 1 0-550 0Z\" fill=\"#515151\" p-id=\"17769\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/btn.svg
// module id = O+kw
// module chunks = 22